import React, { useState } from "react";
import { useCart } from "../../context/CartContext";
import { formatNaira } from "../../productsData";

export default function ProductPurchasePanel({ product }) {
  const { addItem } = useCart();
  const [color, setColor] = useState(product.colors[0]);
  const [size, setSize] = useState(product.sizes[Math.min(2, product.sizes.length - 1)]);
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);

  const handleAddToCart = () => {
    const meta = [size, color !== "One Size" ? color : null].filter(Boolean).join(" · ");
    for (let i = 0; i < qty; i++) {
      addItem(product, meta || undefined);
    }
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  return (
    <div>
      <span className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>{product.category}</span>
      <h1 className="single-service-title" style={{ fontSize: "clamp(1.6rem, 3vw, 2.1rem)" }}>
        {product.name}
      </h1>
      <div className="product-price-row">
        {formatNaira(product.price)} <span className="in-stock">In Stock</span>
      </div>
      <p className="single-service-desc">{product.desc}</p>

      {product.colors.length > 1 && (
        <div className="mb-3">
          <div className="product-option-label">Color: {color}</div>
          <div className="d-flex gap-2">
            {product.colors.map((c) => (
              <button
                key={c}
                type="button"
                title={c}
                className={`color-swatch ${color === c ? "active" : ""}`}
                style={{ background: swatchColor(c) }}
                onClick={() => setColor(c)}
              />
            ))}
          </div>
        </div>
      )}

      {product.sizes.length > 1 && (
        <div className="mb-3">
          <div className="product-option-label">Size</div>
          <div className="d-flex gap-2 flex-wrap">
            {product.sizes.map((s) => (
              <button
                key={s}
                type="button"
                className={`size-btn ${size === s ? "active" : ""}`}
                onClick={() => setSize(s)}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="d-flex gap-3 align-items-center flex-wrap">
        <div className="qty-stepper">
          <button type="button" onClick={() => setQty((q) => Math.max(1, q - 1))}>&minus;</button>
          <span>{qty}</span>
          <button type="button" onClick={() => setQty((q) => q + 1)}>+</button>
        </div>
        <button className="btn-mu-solid" style={{ width: "auto" }} onClick={handleAddToCart}>
          {added ? "✓ Added to Cart" : `Add to Cart — ${formatNaira(product.price * qty)}`}
        </button>
      </div>
    </div>
  );
}

// Turns a plain color name into something visible on a small round swatch.
function swatchColor(name) {
  const map = {
    Black: "#1a1a1a",
    Red: "#c0392b",
    White: "#f2f2f2",
    Navy: "#1b2a4a",
    Maroon: "#5a1f2e",
    Yellow: "#e8c547",
    Natural: "#d8cdb8",
    Rust: "#a4522a",
    Olive: "#5c5c3f",
    Purple: "#4c2a8c",
    Orange: "#ff7a3d"
  };
  return map[name] || "#ccc";
}
